import { observer } from 'mobx-react-lite';

import { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';

import styles from './CategoriesGrid1S.module.scss';
import { Body } from './components/Body';

const CategoriesGrid1S = ({ category }: BlockCommonProps) => {
  const { subcategory, name } = category;

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <h3 className={styles.title}>{name}</h3>
        <ViewAllButton link="/shop" />
      </div>
      <Body items={subcategory} />
    </div>
  );
};

export default observer(CategoriesGrid1S);
